import { useQuerySampleTrackingV2 } from '@modules/study-insights/hooks';
import { UseQueryResult } from '@tanstack/react-query';
import { SampleTrackingResponse } from '../types';
import { UseSampleTrackingRequest } from './useQuerySampleTrackingStrategy.types';

const useQuerySampleTrackingStrategy = (
  args: UseSampleTrackingRequest,
): UseQueryResult<SampleTrackingResponse | undefined> => {
  const { params, options } = args;
  return useQuerySampleTrackingV2(params, options);
};

export default useQuerySampleTrackingStrategy;
